/**
 * Services — 인증이지 5가지 핵심 서비스 카드 (new design)
 *
 * preview/index.html 의 .services 1:1 매칭
 *  - 5컬럼 그리드 (1280 이하 3컬럼, 767 이하 1컬럼)
 *  - 각 카드: 영문 라벨 + 한글 제목 + 설명 + 회색 주석 + CTA 링크
 *
 * 데이터: SERVICES (config/constants.ts)
 */
import { SERVICE_LIST, type ServiceType } from '@/config/constants';

export interface ServicesProps {
  /** 카드 하단 '상담 신청하기' 클릭 시 호출. 어떤 서비스가 클릭됐는지 id 전달. */
  onSelect: (serviceId: ServiceType) => void;
}

export function Services({ onSelect }: ServicesProps) {
  return (
    <section className="services" id="services">
      <div className="section-head">
        <span className="section-tag">SERVICES</span>
        <h2 className="section-title">
          기업 성장을 위한<br />
          <span className="accent">5가지 핵심 서비스</span>
        </h2>
        <p className="section-sub">
          각 분야 전문 컨설턴트가 서류 준비부터 취득·운영까지 전 과정을{' '}
          <span className="nowrap-group">컨설팅·지원합니다.</span>
        </p>
      </div>

      <div className="services-grid">
        {SERVICE_LIST.map((svc) => (
          <article key={svc.id} className="service-card">
            <span className="service-label">{svc.labelEn}</span>
            <h3 className="service-title">{svc.label}</h3>
            <p className="service-desc">{svc.desc}</p>
            <p className="service-note">{svc.note}</p>
            <button
              type="button"
              className="service-cta"
              onClick={() => onSelect(svc.id)}
              aria-label={`${svc.label} 상담 신청하기`}
            >
              상담 신청하기 →
            </button>
          </article>
        ))}
      </div>
    </section>
  );
}
